/** Calendar page copy. EN mirrors SV until proper translations are added. */
export const pagesCalendarSv = {
    legend: {
        title: 'Förklaring',
        incRights: 'Sista dagen för att erhålla rätter',
        exRights: 'Första handelsdagen exklusive rätter',
        rightsEnd: 'Sista handelsdagen för rätter',
        subscription: 'Teckningsperiod',
        ipo: 'Första handelsdagen',
    },
    chips: {
        inc: 'Ink',
        ex: 'Ex',
        tr: 'TR',
        subscription: 'Teckning',
        ipo: 'IPO',
    },
    filters: {
        completedIssuesAndOptions: 'Genomförda emissioner och optioner',
        unlistedOptions: 'Onoterade optioner',
        lists: 'Listor',
        financialAdvisor: 'Finansiell rådgivare',
        others: 'Övriga',
    },
    tooltip: {
        subscriptionPrice: 'Teckningskurs',
        perUnit: 'per unit',
        perShare: 'per aktie',
        unit: 'Unit',
        list: 'Lista',
        financialAdvisor: 'Finansiell rådgivare',
        noFinancialAdvisor: 'Ingen finansiell rådgivare',
        warrantsPlaceholder: 'X teckningsoptioner',
        sharesPlaceholder: 'X aktier',
    },
    size: {
        noNewShares: 'Inga nya aktier emitteras',
        notYetDetermined: 'Ej fastställt ännu',
    },
}
